import React from 'react';
import './circleHightlightCrd.css'

function C2wCircleHightlightCrd( { obj } ) {
    return (
        <div className='C2wCircleHightlightCrd_ctn'>
            <div className='circle'>
                <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 2.34375L26 16.8438L3 31.3438V2.34375Z" fill="#FCAE10" fill-opacity="0.2" />
                    <path d="M0 4.00612C0.000180419 0.841604 3.50111 -1.06941 6.16309 0.641863L26.1309 13.4788C28.5802 15.0533 28.5801 18.6327 26.1309 20.2073L6.16309 33.0442C3.5843 34.702 0.2178 32.9604 0.00976562 29.9729L0 29.6799V4.00612ZM4 29.6799L23.9678 16.843L4 4.00612V29.6799Z" fill="#FCAE10" />
                </svg>
            </div>
            <div className='C2wCourseDemoLectures_heading_hld'>
                <div className='count'>{obj?.count}</div>
                <div className='title'>{obj?.title}</div>
            </div>
        </div>
    )
}

export default C2wCircleHightlightCrd
